import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from '../../redux/rootReducer'
import { FETCH_USER_DATA } from 'dealer-reducers'
import SignIn from '../organisms/SignIn'
import { useLocation } from 'react-router-dom'
import Spinner from '../atoms/Spinner'

interface Props {
  children: JSX.Element
}

const AuthWrapper = ({ children }: Props): JSX.Element => {
  const authState = useSelector((state: RootReducer) => state.authReducer.authorizedState)
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const skipAuthorization = (): boolean => {
    if (pathname === '/reset-password' || pathname === '/auth/callback') return true
    return Boolean(pathname.match(/\/new-password\/.*/))
  }
  useEffect(() => {
    if (!skipAuthorization()) {
      dispatch(FETCH_USER_DATA())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  if (skipAuthorization()) {
    return <>{children}</>
  }
  if (authState === 'unauthorized') {
    return <SignIn />
  }
  if (authState === 'authorized') {
    return <>{children}</>
  }

  return <Spinner />
}

export default AuthWrapper
